// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"appDownloadButtons_mainWrapper__gFcxz","badgesWrapper":"appDownloadButtons_badgesWrapper__0V8sg","appStoreBadge":"appDownloadButtons_appStoreBadge__J7A1z"};